import api from '../utils/api';

class CGroupsApi {
  getAll = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/cgroups', { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  create = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post('/cgroups', data);

        resolve(res.data);
      } catch (error) {
        console.error(error);
        reject(error);
      }
    });
  };

  update = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/cgroups/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  delete = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.delete(`/cgroups/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
}

const cGroupsApi = new CGroupsApi();
export default cGroupsApi;
